import { render, staticRenderFns } from "./AttachmentUploadModal.vue?vue&type=template&id=28f666a9&scoped=true"
import script from "./AttachmentUploadModal.vue?vue&type=script&lang=ts"
export * from "./AttachmentUploadModal.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentUploadModal.vue?vue&type=style&index=0&id=28f666a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f666a9",
  null
  
)

export default component.exports